import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import demoUserImg from "../../assets/images/users/user-dummy-img.jpg";
import Loader from "../Common/Loader";
import Error from "../Common/Error";
import { getClients } from "../../slices/ManageClient/thunk";

const Clients = ({ clients }) => {

    const apiImageUrl = process.env.REACT_APP_API_IMAGE_URL;

    const colors = ["primary", "secondary", "success", "danger", "warning", "info"];

    return (
        <>
            <Col lg={12} xl={7} xxl={7} className="px-1">
                <Card>
                    <CardHeader className="align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">Client List</h4>
                        <div className="flex-shrink-0">
                            <Link
                                to={'/clients-list'}
                                className="btn btn-soft-primary btn-sm material-shadow-none"
                            >
                                View All Clients
                                <i className="ms-1 ri-arrow-right-line align-bottom"></i>
                            </Link>
                        </div>
                    </CardHeader>

                    <CardBody className="client-list py-0 px-2">
                        <Table className="table table-centered table-hover align-middle table-nowrap mb-0" style={{ width: '100%' }}>
                            <tbody>
                                {clients &&
                                    clients.slice(0, 7).map((client, index) => (
                                        <tr key={index}>
                                            <td style={{ padding: ".2rem .5rem" }}>
                                                <div className="d-flex align-items-center">
                                                    <div className="me-2 flex-shrink-0" style={{width: '1.2rem', height: '1.2rem'}}>
                                                        <div
                                                            className={
                                                                "avatar-title bg-" +
                                                                colors[Math.floor(Math.random() * colors.length)] +
                                                                "-subtle rounded"
                                                            }
                                                        >
                                                            {client.file ? (
                                                                <img src={apiImageUrl + client.file} onError={(e) => { e.target.src = demoUserImg }} alt="..." className="img-fluid p-1 rounded-circle" />
                                                            ) : (
                                                                <span>
                                                                    {client.companyName.charAt(0)}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="mb-0">{client.companyName}</div>
                                                </div>
                                            </td>
                                            <td style={{ padding: ".75rem" }}>
                                                <i className="ri-map-pin-2-line text-primary me-1 align-bottom"></i>{" "}
                                                {client.city}
                                            </td>
                                            <td style={{
                                                padding: ".75rem",
                                                display: 'flex'
                                            }} >
                                                <i className="ri-mail-line text-primary me-1 align-bottom"></i>{" "}
                                                <div style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    width: "100px"
                                                }}>
                                                    {client.email}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </Col>
        </>
    );
};

export default Clients;